var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#E7F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4282_34516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9741 31.4773C36.2024 31.4773 39.6411 28.0065 39.6411 23.7386C39.6411 19.4708 36.2024 16 31.9741 16C27.7458 16 24.3071 19.4708 24.3071 23.7386C24.3071 28.0065 27.7458 31.4773 31.9741 31.4773ZM31.9741 18.5795C34.793 18.5795 37.0854 20.8934 37.0854 23.7386C37.0854 26.5839 34.793 28.8977 31.9741 28.8977C29.1552 28.8977 26.8628 26.5839 26.8628 23.7386C26.8628 20.8934 29.1552 18.5795 31.9741 18.5795Z",
    fill: "#065EEA",
    stroke: "#E7F0FF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2258 47.6826C29.3156 47.6826 26.3905 46.9402 24.1782 45.4554C22.1143 44.0894 20.9858 42.2186 20.9858 40.1844C20.9858 38.1502 22.1143 36.2645 24.1782 34.8837C28.6326 31.9289 35.8487 31.9289 40.2734 34.8837C42.3224 36.2497 43.4657 38.1205 43.4657 40.1547C43.4657 42.1889 42.3373 44.0746 40.2734 45.4554C38.0462 46.9402 35.136 47.6826 32.2258 47.6826ZM25.4105 36.7545C23.9851 37.7048 23.213 38.9223 23.213 40.1992C23.213 41.4613 24 42.6789 25.4105 43.6143C29.1077 46.0939 35.3439 46.0939 39.041 43.6143C40.4664 42.664 41.2385 41.4465 41.2385 40.1695C41.2385 38.9075 40.4516 37.6899 39.041 36.7545C35.3439 34.2897 29.1077 34.2897 25.4105 36.7545Z",
    fill: "#065EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.654 35.8524V37.8123C37.911 38.2558 38.8137 39.4486 38.8137 40.8487V41.9223C38.8137 42.5161 38.331 42.996 37.7339 42.996C37.1367 42.996 36.654 42.5161 36.654 41.9223V40.8487C36.654 40.256 36.1702 39.775 35.5742 39.775C34.9781 39.775 34.4943 40.256 34.4943 40.8487V41.9223C34.4943 42.5161 34.0116 42.996 33.4145 42.996C32.8173 42.996 32.3346 42.5161 32.3346 41.9223V40.8487C32.3346 39.4486 33.2374 38.2558 34.4943 37.8123V34.5709L29.095 34.8071V38.6364C29.7408 39.0079 30.1749 39.7015 30.1749 40.496C30.1749 41.6824 29.2084 42.6433 28.0152 42.6433C26.8219 42.6433 25.8555 41.6824 25.8555 40.496C25.8555 39.7015 26.2896 39.0079 26.9353 38.6364V36.4794V33.9879L29.095 33.3272L34.4943 33.0973L36.654 33.7037V35.8524Z",
    fill: "#065EEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4282_34516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDefault);
export default __webpack_public_path__ + "static/media/doctor-default.e6097e13a29c0b5b2e969193de1d71cc.svg";
export { ForwardRef as ReactComponent };